const ACCOUNT_REMOVAL_NOTICE_KEY = 'account-removal-notice'

export function storeAccountRemovalNotice(message: string): void {
    if (typeof window === 'undefined') return

    window.sessionStorage.setItem(ACCOUNT_REMOVAL_NOTICE_KEY, message)
}

export function consumeAccountRemovalNotice(): string | null {
    if (typeof window === 'undefined') return null

    const message = window.sessionStorage.getItem(ACCOUNT_REMOVAL_NOTICE_KEY)
    window.sessionStorage.removeItem(ACCOUNT_REMOVAL_NOTICE_KEY)

    return message
}
